/*
 * Bealice — subtle fireworks overlay for the hero slideshow.
 * Transparent canvas with fading trails so it layers over any slide image
 * or the code-built twilight backdrop. Pauses when off-screen, when the
 * tab is hidden, and when its slide isn't the active one. Honors
 * prefers-reduced-motion (renders a single static burst instead of animating).
 */
(function () {
  'use strict';

  var PALETTES = {
    gold: ['#FDECB4', '#F7C85A', '#FFF6DD', '#EBAE49', '#F0D089', '#E24B4A', '#6AA6FF'],
    patriotic: ['#F25C5C', '#FFFFFF', '#6AA6FF', '#F7D774', '#FF9A9A', '#AECBFF']
  };
  var PRESETS = {
    subtle: { rate: 1650, count: 52, spread: 3.0 },
    lively: { rate: 780, count: 80, spread: 3.9 }
  };
  var GRAVITY = 0.03;

  function rand(a, b) { return a + Math.random() * (b - a); }

  function Fireworks(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.palette = PALETTES[canvas.dataset.palette] || PALETTES.gold;
    var p = PRESETS[canvas.dataset.intensity] || PRESETS.subtle;
    this.rate = p.rate; this.count = p.count; this.spread = p.spread;
    this.rockets = []; this.parts = [];
    this.acc = 0; this.last = 0; this.running = false; this.raf = 0;
    this.W = 0; this.H = 0; this.dpr = 1;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.resize = this.resize.bind(this);
    this.tick = this.tick.bind(this);
    this.ro = new ResizeObserver(this.resize);
    this.ro.observe(canvas);
    this.resize();
  }

  Fireworks.prototype.resize = function () {
    this.dpr = Math.min(window.devicePixelRatio || 1, 2);
    var r = this.canvas.getBoundingClientRect();
    this.W = r.width; this.H = r.height;
    this.canvas.width = Math.max(1, Math.round(this.W * this.dpr));
    this.canvas.height = Math.max(1, Math.round(this.H * this.dpr));
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  };

  Fireworks.prototype.pick = function () {
    var p = this.palette;
    return Math.random() < 0.72 ? p[(Math.random() * 3) | 0] : p[3 + ((Math.random() * (p.length - 3)) | 0)];
  };

  Fireworks.prototype.launch = function (x) {
    this.rockets.push({
      x: x != null ? x : rand(this.W * 0.14, this.W * 0.86),
      y: this.H + 4,
      vx: rand(-0.3, 0.3),
      vy: -(this.H * 0.0115 + Math.random() * this.H * 0.004),
      ty: rand(this.H * 0.14, this.H * 0.42),
      color: this.pick()
    });
  };

  Fireworks.prototype.burst = function (x, y, color) {
    var n = this.count + ((Math.random() * 16 - 8) | 0), i, a, sp, col;
    for (i = 0; i < n; i++) {
      a = Math.random() * 6.283;
      sp = Math.sqrt(Math.random()) * this.spread * rand(1, 1.4);
      col = Math.random() < 0.82 ? color : this.pick();
      this.parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 0.6, life: 1, decay: rand(0.008, 0.02), color: col, r: rand(1, 2.4) });
    }
    for (i = 0; i < 9; i++) {
      a = Math.random() * 6.283; sp = Math.random() * 1.2;
      this.parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, decay: 0.03, color: '#FFFFFF', r: 1.2 });
    }
  };

  Fireworks.prototype.drawParts = function () {
    var c = this.ctx, i, p;
    c.globalCompositeOperation = 'lighter';
    for (i = this.rockets.length - 1; i >= 0; i--) {
      var r = this.rockets[i];
      c.globalAlpha = 0.9; c.fillStyle = r.color;
      c.beginPath(); c.arc(r.x, r.y, 1.6, 0, 6.2832); c.fill();
    }
    for (i = this.parts.length - 1; i >= 0; i--) {
      p = this.parts[i];
      c.globalAlpha = p.life < 0 ? 0 : p.life; c.fillStyle = p.color;
      c.beginPath(); c.arc(p.x, p.y, p.r, 0, 6.2832); c.fill();
    }
    c.globalAlpha = 1;
  };

  Fireworks.prototype.tick = function (t) {
    if (!this.running) return;
    if (!this.last) this.last = t;
    var dt = t - this.last; this.last = t;
    var c = this.ctx;

    // Fade previous frame (transparent trails) via destination-out.
    c.globalCompositeOperation = 'destination-out';
    c.globalAlpha = 0.20; c.fillStyle = '#000';
    c.fillRect(0, 0, this.W, this.H);
    c.globalAlpha = 1;

    this.acc += dt;
    if (this.acc >= this.rate) {
      this.acc = 0; this.launch();
      if (this.count >= 80 && Math.random() < 0.4) this.launch();
    }

    for (var i = this.rockets.length - 1; i >= 0; i--) {
      var r = this.rockets[i];
      r.x += r.vx; r.y += r.vy; r.vy += 0.02;
      if (r.vy >= 0 || r.y <= r.ty) { this.burst(r.x, r.y, r.color); this.rockets.splice(i, 1); }
    }
    for (var j = this.parts.length - 1; j >= 0; j--) {
      var p = this.parts[j];
      p.vx *= 0.985; p.vy = p.vy * 0.985 + GRAVITY; p.x += p.vx; p.y += p.vy; p.life -= p.decay;
      if (p.life <= 0) this.parts.splice(j, 1);
    }

    this.drawParts();
    this.raf = window.requestAnimationFrame(this.tick);
  };

  Fireworks.prototype.start = function () {
    if (this.running || this.reduce) return;
    this.running = true; this.last = 0;
    if (!this.seeded) {
      this.seeded = true;
      var self = this;
      setTimeout(function () { self.launch(self.W * 0.32); }, 250);
      setTimeout(function () { self.launch(self.W * 0.66); }, 1000);
    }
    this.raf = window.requestAnimationFrame(this.tick);
  };

  Fireworks.prototype.stop = function () {
    this.running = false;
    if (this.raf) window.cancelAnimationFrame(this.raf);
    this.raf = 0;
  };

  Fireworks.prototype.staticBurst = function () {
    this.burst(this.W * 0.32, this.H * 0.38, this.pick());
    this.burst(this.W * 0.68, this.H * 0.30, this.pick());
    this.drawParts();
  };

  function slideIsActive(canvas) {
    var slide = canvas.closest('.slideshow__slide');
    return !slide || slide.classList.contains('is-selected');
  }

  function init(canvas) {
    if (canvas.__bealiceFw) return;
    var fw = new Fireworks(canvas);
    canvas.__bealiceFw = fw;

    if (fw.reduce) { fw.staticBurst(); return; }

    var onScreen = true;
    function sync() {
      if (!document.hidden && onScreen && slideIsActive(canvas)) fw.start();
      else fw.stop();
    }

    var io = new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting; sync();
    }, { threshold: 0.05 });
    io.observe(canvas);

    document.addEventListener('visibilitychange', sync);

    var slide = canvas.closest('.slideshow__slide');
    if (slide) {
      var mo = new MutationObserver(sync);
      mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
    }
    sync();
  }

  function boot() {
    var list = document.querySelectorAll('canvas.bealice-fw');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-scan when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
